import React from 'react'

const Version = (props) => {

  return (
    <span>
      <div style={{ width: '100%' }} className="element-col-align-center"><label className='element-form-label'>
        {'Version'} 1.4.1
      </label></div>
    </span>
  )
}

export default Version
